import React, { useEffect, useMemo, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Icon, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { AppSnackbar } from '@sierralabs/core-ui';
import { useEntityContext } from '@sierralabs/entity-ui';
import { QueryManager } from '@sierralabs/query-core';
import { defaultQueryBuilderPlugins, getQuerySelectValue, useRunQuery } from '@sierralabs/query-ui';
export const ExportReportDialog = props => {
    var _a;
    const { open, query, report, onCancel } = props;
    const [error, setError] = useState();
    const [csvData, setCsvData] = useState();
    const [isInProgress, setIsInProgress] = useState(false);
    const { entities } = useEntityContext();
    const { queryData, isRunningQuery, runQueryError, runPaginatedQuery } = useRunQuery();
    const queryManager = useMemo(() => {
        return new QueryManager(query, entities || [], defaultQueryBuilderPlugins);
    }, [entities, query]);
    useEffect(() => {
        if (query.config) {
            runPaginatedQuery(query.config);
        }
    }, [query, query.config, runPaginatedQuery]);
    // generate CSV
    useEffect(() => {
        if (!queryData) {
            return;
        }
        setIsInProgress(true);
        // the following is synchronise so use setTimeout to display loading
        // progress while formulating CSV for large data sets.
        setTimeout(() => {
            var _a, _b, _c;
            // add labels to CSV first row
            const labels = (((_a = query.config) === null || _a === void 0 ? void 0 : _a.selects) || []).map(select => {
                var _a;
                const columnMap = queryManager.queryAliasColumnMap.find(cm => cm.path === select.selection);
                return ((_a = columnMap === null || columnMap === void 0 ? void 0 : columnMap.column) === null || _a === void 0 ? void 0 : _a.displayName) || select.selection || '';
            });
            // process all data rows
            const selects = ((_c = (_b = queryManager.query) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.selects) || [];
            const rows = queryData.data.map(item => {
                const row = selects.map(select => {
                    var _a;
                    const value = getQuerySelectValue({
                        item,
                        select,
                        expressionMap: (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config
                    });
                    return value ? `"${value.toString().replace(/"/g, '""')}"` : '""';
                });
                return row;
            });
            const csvRows = [labels, ...rows];
            const csvData = csvRows.map((row) => row.join(',')).join('\r\n');
            setCsvData(csvData);
            setIsInProgress(false);
        });
    }, [(_a = query.config) === null || _a === void 0 ? void 0 : _a.selects, queryData, queryManager]);
    useEffect(() => {
        setError(runQueryError);
    }, [runQueryError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Export Report"),
        React.createElement(DialogContent, null,
            React.createElement(Typography, { variant: 'body1' },
                "Download CSV with for ",
                React.createElement("b", null, (report === null || report === void 0 ? void 0 : report.query.name) || 'query results'),
                "."),
            React.createElement(List, null,
                React.createElement(ListItem, null,
                    React.createElement(ListItemIcon, null, isRunningQuery ? (React.createElement(CircularProgress, { size: 20 })) : (React.createElement(Icon, null, "check"))),
                    React.createElement(ListItemText, { primary: 'Retreiving report data.' })),
                React.createElement(ListItem, null,
                    React.createElement(ListItemIcon, null, isRunningQuery ? (React.createElement(Icon, null, "more_horiz")) : isInProgress ? (React.createElement(CircularProgress, { size: 20 })) : (React.createElement(Icon, null, "check"))),
                    React.createElement(ListItemText, { primary: 'Generating CSV file.' })))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onCancel }, "Cancel"),
            React.createElement(Button, { color: 'primary', variant: 'outlined', disabled: !csvData, onClick: () => {
                    if (!csvData || isInProgress) {
                        return;
                    }
                    const a = document.createElement('a');
                    const blob = new Blob([csvData], {
                        type: 'text/csv;charset=utf-8'
                    });
                    a.textContent = 'download';
                    a.download = ((report === null || report === void 0 ? void 0 : report.query.name) || 'report')
                        .replace(/ /g, '_')
                        .toLowerCase()
                        .concat('.csv');
                    a.href = URL.createObjectURL(blob);
                    a.click();
                    a.href = '#';
                    setIsInProgress(false);
                    onCancel();
                } }, isInProgress ? React.createElement(CircularProgress, null) : 'Download CSV')),
        React.createElement(AppSnackbar, { severity: 'error', open: !!error, onClose: () => setError(undefined) }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')));
};
export default ExportReportDialog;
//# sourceMappingURL=ExportReportDialog.js.map